import { Button, Center, Loader } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom'
import { Consent } from './Consent';
import { RequestAccessToken } from './RequestAccessToken'
import { ApiAccess, ShowAccess } from './ShowAccess'
import { axiosWrapper, ms } from './utils'

export const HomePage = () => {
    const [searchParams] = useSearchParams()
    const code = searchParams.get('code')

    const { data, isLoading, refetch } = useQuery<ApiAccess>({
        queryKey: ['access'],
        queryFn: () => axiosWrapper(axios({
            url: `/api/access`,
        })),
    })

    useEffect(() => {
        void refetch()
    }, [code, refetch])

    if (isLoading || !data) return (
        <Loader />
    )

    if (!data?.consent) return (
        <Consent refetch={refetch} />
    )

    return (
        <>
            {code ? (
                <RequestAccessToken code={code} />
            ) : (data?.hasAccess ? (
                    <ShowAccess access={data} refetch={refetch} />
                ) : (
                    <Center>
                        <div style={{ textAlign: 'center' }}>
                            <p>You have consented to use this mail tester application. Please click the button below to retrieve access.</p>
                            <Button component="a" href={ms.link} leftSection={(
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
                                    <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                                    <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
                                    <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
                                    <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
                                </svg>
                            )} style={{
                                backgroundColor: '#FFFFFF',
                                fontWeight: 600,
                                color: '#5E5E5E',
                                border: '1px solid #8C8C8C',
                                borderRadius: 0,
                            }}>
                                Sign in with Microsoft
                            </Button>
                        </div>
                    </Center>
                )
            )}
        </>
    )
}
